import { makeStyles } from '@mui/styles';

export default makeStyles({
  icon: {
    width: 16,
    height: 16,
  },
});
